<!-- [(ngModel)]="value3" -->
<p-inputNumber
  inputId="horizontal"
  [(ngModel)]="initialQuantity"
  [min]="min"
  [step]="1"
  [max]="max"
  [showButtons]="true"
  buttonLayout="horizontal"
  spinnerMode="horizontal"
  incrementButtonIcon="ph ph-plus"
  decrementButtonIcon="ph ph-minus"
  size="1"
  (onInput)="updateQuantity($event)"
  [styleClass]="changedClass"
/>
<!-- decrementButtonClass="p-button-danger"
  incrementButtonClass="p-button-success" -->
<!-- mode="currency" -->
<!-- currency="EUR" -->
